import AutoNumeric from 'autonumeric';

export default function inputFormat(input) {
  // eslint-disable-next-line no-unused-vars
  const inputElem = new AutoNumeric(input, {
    decimalCharacter: '.',
    allowDecimalPadding: false,
    digitGroupSeparator: ',',
    modifyValueOnWheel: false,
  });
}
